import type { ChatActivityAnswer } from '@app/@types/redux/answer';
import type { ChatActivityOptions, SimulationChatItem } from '@app/@types/redux/pageElement';
import type { PageElementProps } from '@components/Projects/TakeProject';
import { useAppSelector } from '@state/redux/store';
import { type OpenAIRole } from '@state/utils/openai';
import moment from 'moment';
import { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import ChatBox from './ChatBox';
import ChatMenu from './ChatMenu';
import './index.scss';
import { Chats } from './tempConstants';

export interface ChatItem {
  id: string;
  message: SimulationChatItem['attributes']['message'];
  sender: OpenAIRole;
  timestamp: string;
  simulationChatItem?: SimulationChatItem;
  openedAt: string | null;
}
interface ChatActivityProps extends PageElementProps {
  tempMessages?: ChatItem[];
}
const TempChat: React.FC<ChatActivityProps> = (props: ChatActivityProps) => {
  const { tempMessages } = props;
  const topicWizardData = useAppSelector(
    (state) =>
      state.projects.currentProject.project.attributes.options.creationOptions.topicWizardData
  );
  const sampleChatActivityOptions: ChatActivityOptions = {
    activityData: {
      submissionQuestions: [
        {
          id: 'q1',
          question: 'What is your name?',
          isDefault: true,
          visible: true,
          criteria: ['required'],
          modelAnswer: 'John Doe',
        },
        {
          id: 'q2',
          question: 'Describe your project.',
          isDefault: false,
          visible: true,
          criteria: ['required', 'length:100'],
        },
      ],
    },
    chatActivityData: {
      id: 'chat1',
      value: 'Chat Activity 1',
      description: 'This is a sample chat activity.',
      purpose: 'To facilitate communication among team members.',
      rules: [
        {
          id: 'r1',
          checked: true,
          description: 'Be respectful to others.',
          defaultRule: true,
        },
        {
          id: 'r2',
          checked: false,
          description: 'No spamming.',
          defaultRule: false,
        },
      ],
      users: [
        {
          id: 'u1',
          name:
            topicWizardData.workplaceScenario?.learnerRoleReportingManager.reportingManager.name ??
            'Alice',
          profileImage:
            topicWizardData.workplaceScenario?.learnerRoleReportingManager.reportingManager
              .avatarUrl ?? 'https://randomuser.me/api/portraits/women/1.jpg',
          designation: 'Developer',
          personality: 'Friendly',
          organization: 'Tech Corp',
        },
        {
          id: 'u2',
          name: 'Bob',
          profileImage: 'https://randomuser.me/api/portraits/men/1.jpg',
          designation: 'Designer',
          personality: 'Creative',
          organization: 'Design Studio',
        },
      ],
      dependentActivityId: 'activity123',
      duration: '30 minutes',
    },
    reviewData: {
      selectedReviewTypes: ['peer', 'self'],
      reviewType: 'star',
      starRatingQuestions: [
        {
          id: 'srq1',
          question: 'How would you rate the overall experience?',
          isDefault: true,
          visible: true,
          criteria: ['required'],
        },
        {
          id: 'srq2',
          question: 'How likely are you to recommend this to a friend?',
          isDefault: false,
          visible: true,
          criteria: ['required'],
        },
      ],
      peerReviewCompetencyQuestions: [
        {
          id: 'prcq1',
          question: 'How well did the team collaborate?',
          isDefault: true,
          visible: true,
          criteria: ['required'],
        },
        {
          id: 'prcq2',
          question: 'How effectively did the team communicate?',
          isDefault: false,
          visible: true,
          criteria: ['required'],
        },
      ],
    },
  };
  const currentAnswer = props.currentAnswer as ChatActivityAnswer | undefined;

  const [searchboxValue, setSearchboxValue] = useState('');

  // const user = (pageElement.attributes.options as ChatActivityOptions).chatActivityData.users[0];
  const user = sampleChatActivityOptions.chatActivityData.users[0];

  const [selectedChat, setSelectedChat] = useState(user.id);

  const [messages, setMessages] = useState<ChatItem[]>(
    currentAnswer?.messages ?? tempMessages ?? []
  );

  const chats = [
    {
      id: user.id,
      name: user.name,
      lastMessage: messages[messages.length - 1]?.message ?? '',
      lastMessageTime: moment(messages[messages.length - 1]?.timestamp ?? '').format('hh:mm A'),
      profilePicture: user.profileImage,
      messageStatus: 'default',
      online: true,
    },
    ...Chats,
  ];

  return (
    <div className="chat-container">
      <div className="left-side">
        <div className="chat-search-box-container">
          <div>
            <FaSearch className="chat-search-box-fixed-label" />
          </div>
          <div className="chat-input-wrapper">
            <input
              type="text"
              value={searchboxValue}
              onChange={(e) => {
                setSearchboxValue(e.target.value);
              }}
              placeholder="Search..."
            />
          </div>
        </div>
        {chats.map((chat, index) => (
          <ChatMenu
            key={index}
            chat={chat}
            selected={selectedChat === chat.id}
            handleOnClick={() => {
              setSelectedChat(chat.id);
            }}
          />
        ))}
      </div>
      <div className="right-side">
        <ChatBox messages={messages} avatar={user} setMessages={setMessages} disabled={true} />
      </div>
    </div>
  );
};
export default TempChat;
